import {FormikHelpers} from 'formik';
import _ from 'lodash';
import {notify} from '@gemcook/notification';

import api from '@api';
import paths from '@paths';
import constants from '@constants';

export const getQueryParams = (location: any) => {
  // 最初の1文字(?)を除いた文字列を取得する
  const query = location.search.substring(1).trim();
  // (&) で文字列を配列に分割する
  const parameters = query.split('&');
  // クエリパラメーターの配列を作成する
  let queryParams = [''];
  parameters.forEach((targetParam: string) => {
    const _param = targetParam.split('=')[1];
    queryParams.push(_param);
  });
  // 初期値の空文字を取り除く
  const result = queryParams.filter((param: string) => {
    return param.length;
  });

  return result;
};

export const submit = async (
  injuryStatus: number,
  message: string,
  id: string,

  formikHelpers: FormikHelpers<any>,
  history: any
) => {
  try {
    await api.notifications.answer([
      {
        injuryStatus,
        message,
        id,
      },
    ]);
    formikHelpers.setSubmitting(false);
    history.push(paths.safety.thank);
  } catch (error) {
    console.error(error);
  }
};

export const submitStopMail = async (
  query: {id: string},
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  setIsLoading(true);
  try {
    await api.users.sendComplaint({
      userNotificationId: query.id,
      isSMSBounced: true,
    });
    notify('配信停止を行いました。画面を閉じてください。', 'success');
  } catch (error) {
    notify(constants.ERRORS.UNKNWON, 'error');
  } finally {
    setIsModal(false);
    setIsLoading(false);
  }
};

// SMSでの安否確認か、Eメールでの安否確認かを判定する
export const getMailType = (query: any) => {
  const querys = Object.keys(query);
  return _.includes(querys, 'email');
};
